<template>
  <TableGradient
      icon-name="broadcast-tower"
      :title="$t('core_companies.index.listagem_empresas')"
      :text-empty="$t('core_companies.index.empresa_nao_encontrada')"
      route-new="corecompanies.create"
      :text-new="$t('core_companies.index.criar_empresa')"
      :fields="fields"
      :items="companies"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('corecompanies/listAllPaginated', evt)"
      table-data
      disable-filters
  >
    <template v-slot:cell(id)="{ index, item: { id }}">
      <router-link :id="`link-edit-${index}`" :to="{ name: 'corecompanies.edit', params: { id }}" class="font-weight-bold">
        {{ $t('core_companies.index.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="{ item: { status }}">
      <span :class="{'rounded-pill p-1 ': true, 'badge badge-success': status === 'success', 'badge badge-danger': status === 'error'}">
          <i :class="status === 'success' ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      companies: 'corecompanies/all',
      paginator: 'corecompanies/pagination',
      store_isLoading: 'corecompanies/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'core_companies.mnemonic', label: this.$t('core_companies.index.apelido'), sortable: true},
        {key: 'core_companies.name', label: this.$t('core_companies.index.nome'), sortable: true},
        {key: 'core_companies.veus_company_id', label: 'Veus ID', sortable: true},
        {key: 'provider.name', label: this.$t('core_companies.index.fornecedor'), sortable: true, keyFullName: 'provider.name'},
        {key: 'id', label: 'Editar'}
      ]
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/listAllPaginated'
    ])
  },
  mounted() {
    this['corecompanies/listAllPaginated'](this.paginator)
    this.mounted = true
  }
}
</script>

<style scoped>
</style>